import { history, isAuthenticated, removeUserToken } from "helpers";
import { useWindowSize } from "helpers/hooks";
import { icons, images } from "helpers/images";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import { BsChevronRight } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useLocation } from "react-router-dom";
import { apiMethods, endPoints } from "service/endpoints";
import { request } from "service/request";
import CommonModal from "../CommonModal";
import ListGroup from "../ListGroup";
import styles from "./styles.module.scss";
import { fetchSignupDetails } from "redux/Actions/signupDetailsActions";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import { styled, useTheme } from "@mui/material/styles";
import Accordion from "react-bootstrap/Accordion";
import { MenuItems } from "../DashbordSidebar";
import { logout } from "service/auth";
export default function LandingFooterComponent({
  data,
  getAllMeta,
  handleMouseEnter,
  handleMouseLeave,
}) {
  const dispatch = useDispatch();
  const { width: screenSize } = useWindowSize();
  const profileRef = useRef();
  const location = useLocation();
  const [sidebar, setSidebar] = useState(false);
  const [dropDownStatus, setDropDownStatus] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const optionsRef = useRef(null);
  const profileMenuRef = useRef(null);
  const showSidebar = () => setSidebar(!sidebar);
  const [loginOpen, setLoginOpen] = useState(false);
  const handleShow = () => setLoginOpen(true);
  const handleClose = () => setLoginOpen(false);
  const [openMobileMenu, setOpenMobileMenu] = useState(false);
  const toggleDrawer = (newOpen) => () => {
    setOpenMobileMenu(newOpen);
  };

  const profiles = [
    {
      name: "Profile",
      svg: icons.Profile,
      routeTo: "/portal/profile",
    },
    {
      name: "My Packages",
      svg: icons.Packages,
      routeTo: "/portal/packages",
    },
    {
      name: "Logout",
      svg: icons.LogoutIcon,
      routeTo: "/auth/login",
    },
  ];

  if (window.innerWidth < 600) {
    profiles.splice(2, 0, {
      name: "Refer & Earn",
      svg: icons.Profile,
      routeTo: "/portal/referral",
    });
  }
  const [open, setOpen] = useState(false);

  /* useOnClickOutside(profileRef, () => setOpen(false)); */

  useEffect(() => {
    function handleClickOutside(event) {
      if (optionsRef.current && !optionsRef.current.contains(event.target)) {
        setShowOptions(false);
      }
      if (
        profileMenuRef.current &&
        !profileMenuRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [optionsRef, profileMenuRef]);

  useEffect(() => {
    if (screenSize > 991 && open) {
      setOpen(false);
      setShowOptions(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [screenSize]);

  const handleRouting = () => {
    // if (!data?.default_exam?.is_subscribed) {
    history.push("/portal");
    // } else {
    //   history.push("/dashboard/postsubscription");
    // }
  };

  const handleProfileMenu = async (menu) => {
    if (menu === "Logout") {
      logout();
    } else {
      history.push({
        pathname: menu["routeTo"],
        state: {
          tab: menu["name"],
        },
      });
    }
    setOpen(false);
  };

  const isSubscribed = data?.default_exam?.is_subscribed || false;

  const getHeaderFeatures = useMemo(() => {
    let headerFeatures = data?.default_exam?.features || [];
    headerFeatures = [{ feature: "Dashboard", items: {} }, ...headerFeatures];
    return headerFeatures;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.default_exam?.features]);

  return (
    <div className="footer">
      <div className="flex flex-wrap align-start justify-center 2md:!justify-between ">
        <div className="flex flex-col text-center justify-center 2md:!justify-normal 2md:!text-left 2md:!border-none  lg:!gap-10 2sm:!gap-5 gap-3 lg:!p-10 2sm:!p-5 p-3">
          <a href="https://www.zynerd.com/" className="logo-landing">
            <img src={images.zlogo} className="image-landing" />
          </a>
          <div className="links column-landing gap-12-landing align-start-landing">
            <a href="/contact-us" className="link fw-bold">
              Contact Us
            </a>
            <a href="/careers" className="link fw-bold">
              Careers
            </a>
            <a href="/package-policy" className="link fw-bold">
              Package Policy
            </a>
            <a href="/privacy-policy" className="link fw-bold">
              Privacy Policy
            </a>
            <a href="/terms-and-conditions" className="link fw-bold">
              Terms of Service
            </a>
          </div>
        </div>
        <div className="flex flex-wrap justify-center">
          <div
            className={`${styles.examLinks} flex flex-col gap-4 2lg:!px-16 lg:!px-10 lg:!py-10 md:!px-7 md:!py-5 sm:!px-10 sm:!py-8 !px-3 !py-4`}
          >
            <div
              className={`${styles.examSticker} text-4xl font-black lg:mb-10 2md:m5-8 mb-3 br-2 ${styles.shadow} bg-[#b0ddff]`}
            >
              UG
            </div>
            <div className="flex flex-col gap-4 lg:!gap-10 ">
              <div className="flex gap-3 2sm:!gap-4">
                <a
                  href="https://zynerd.quora.com/"
                  target="_blank"
                  className={styles.link}
                >
                  <img
                    src={icons.darkQuora}
                    alt=""
                    className="w-6 h-6 2md:!w-4 2md:!h-4 lg:!w-6 lg:!h-6"
                  />
                </a>
                <a
                  href="https://www.facebook.com/zynerdneetug"
                  target="_blank"
                  className={styles.link}
                >
                  <img
                    src={icons.darkFacebook}
                    alt=""
                    className="w-6 h-6 2md:!w-4 2md:!h-4 lg:!w-6 lg:!h-6"
                  />
                </a>
                <a
                  href="https://www.instagram.com/zynerdneetug/"
                  target="_blank"
                  className={styles.link}
                >
                  <img
                    src={icons.darkInstagram}
                    alt=""
                    className="w-6 h-6 2md:!w-4 2md:!h-4 lg:!w-6 lg:!h-6"
                  />
                </a>
                <a
                  href="https://x.com/ZyNerdNeetUG/"
                  target="_blank"
                  className={styles.link}
                >
                  <img
                    src={icons.darkX}
                    alt=""
                    className="w-6 h-6 2md:!w-4 2md:!h-4 lg:!w-6 lg:!h-6"
                  />
                </a>
                <a
                  href="https://t.me/zynerdneetugchannel"
                  target="_blank"
                  className={styles.link}
                >
                  <img
                    src={icons.darkTelegram}
                    alt=""
                    className="w-6 h-6 2md:!w-4 2md:!h-4 lg:!w-6 lg:!h-6"
                  />
                </a>
                <a
                  href="https://www.youtube.com/@zynerdneetug"
                  target="_blank"
                  className={styles.link}
                >
                  <img
                    src={icons.darkYoutube}
                    alt=""
                    className="w-6 h-6 2md:!w-4 2md:!h-4 lg:!w-6 lg:!h-6"
                  />
                </a>
              </div>
              <div className="flex gap-3 w-full">
                <a
                  href="https://www.youtube.com/@zynerdneetug"
                  target="_blank"
                  className={`${styles.buttonBlack} w-full py-2 px-6 2md:!py-1 2m:!px-4 lg:!py-2 lg:!px-6 rounded text-center font-satoshi font-bold text-md`}
                >
                  Videos
                </a>
                <a
                  href="/packages?exam=neet-ug"
                  className={`${styles.buttonBlack} w-full py-2 px-6 2md:!py-1 2m:!px-4 lg:!py-2 lg:!px-6 rounded text-center font-satoshi font-bold text-md`}
                >
                  Packages
                </a>
              </div>
            </div>
          </div>
          <div
            className={`${styles.examLinks} flex flex-col gap-4 2lg:!px-16 lg:!px-10 lg:!py-10 sm:!px-8 sm:!py-5 !px-3 !py-4`}
          >
            <div
              className={`${styles.examSticker} text-4xl font-black lg:mb-10 2sm:m5-8 mb-3 br-2 ${styles.shadow} bg-[#ffcbae]`}
            >
              PG
            </div>
            <div className="flex flex-col gap-4 lg:!gap-10 ">
              <div className="social-media-links flex gap-3 2sm:gap-4">
                <a
                  href="https://zynerd.quora.com/"
                  target="_blank"
                  className={styles.link}
                >
                  <img
                    src={icons.darkQuora}
                    alt=""
                    className="w-6 h-6 2md:!w-4 2md:!h-4 lg:!w-6 lg:!h-6"
                  />
                </a>
                <a
                  href="https://www.facebook.com/zynerdneetpg"
                  target="_blank"
                  className={styles.link}
                >
                  <img
                    src={icons.darkFacebook}
                    alt=""
                    className="w-6 h-6 2md:!w-4 2md:!h-4 lg:!w-6 lg:!h-6"
                  />
                </a>
                <a
                  href="https://www.instagram.com/zynerdneetpg/"
                  target="_blank"
                  className={styles.link}
                >
                  <img
                    src={icons.darkInstagram}
                    alt=""
                    className="w-6 h-6 2md:!w-4 2md:!h-4 lg:!w-6 lg:!h-6"
                  />
                </a>
                <a
                  href="https://x.com/HelloZyNerd"
                  target="_blank"
                  className={styles.link}
                >
                  <img
                    src={icons.darkX}
                    alt=""
                    className="w-6 h-6 2md:!w-4 2md:!h-4 lg:!w-6 lg:!h-6"
                  />
                </a>
                <a
                  href="https://t.me/zynerdneetpg2023"
                  target="_blank"
                  className={styles.link}
                >
                  <img
                    src={icons.darkTelegram}
                    alt=""
                    className="w-6 h-6 2md:!w-4 2md:!h-4 lg:!w-6 lg:!h-6"
                  />
                </a>
                <a
                  href="https://www.youtube.com/@ZyNerdNEETPG"
                  target="_blank"
                  className={styles.link}
                >
                  <img
                    src={icons.darkYoutube}
                    alt=""
                    className="w-6 h-6 2md:!w-4 2md:!h-4 lg:!w-6 lg:!h-6"
                  />
                </a>
              </div>
              <div className="flex  gap-3 w-full">
                <a
                  href="https://www.youtube.com/@ZyNerdNEETPG"
                  target="_blank"
                  className={`${styles.buttonBlack} w-full py-2 px-6 2md:!py-1 2m:!px-4 lg:!py-2 lg:!px-6 rounded text-center font-satoshi font-bold text-md`}
                >
                  Videos
                </a>
                <a
                  href="/packages?exam=neet-pg"
                  className={`${styles.buttonBlack} w-full py-2 px-6 2md:!py-1 2m:!px-4 lg:!py-2 lg:!px-6 rounded text-center font-satoshi font-bold text-md`}
                >
                  Packages
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.additionalLinksWrapper}>
          <div class="flex gap-4 w-full px-6 py-6 justify-center">
            <div class={`${styles.copyright} font-semibold`}>
              © 2025 Frank & David Labs Private Limited
            </div>
          </div>
        </div>
      </div>
      <div></div>
    </div>
  );
}
